export const buildRegistrationData = ({
  methods,
  voucherValid,
  calculateSchedulePricing
}) => {
  const values = methods.getValues();

  const formData = {
    fullName: values.fullName,
    institution: values.institution,
    officialRepresentative: values.officialRepresentative,
    email: values.email,
    phone: values.phone,
    notes: values.notes,
  };

  const pricing = calculateSchedulePricing(
    values.schedules,
    voucherValid
  );

  return {
    formData,
    schedules: values.schedules,
    ...pricing,
  };
};